// extracted by mini-css-extract-plugin
module.exports = {"save_for_later_btn":"saved-for-later_save_for_later_btn__Te17v"};